import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { LogGroupRow } from "namirasoft-log";
import { LogRoutes } from "./LogRoutes";
import { LogGroupInputRow, LogRow, LogCreateRow } from "namirasoft-log";
import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, IDFormatter, IntegerFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { LogMenus } from "./LogMenus";
import { LogProps } from "./LogProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { FilterItem, IStorageLocal, SortItem } from "namirasoft-core";

export class LogEntities
{
	static log(props: NSARouterMakerResult & LogProps, log_group_id: string): IEntityInfo<LogRow, LogCreateRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
		return {
			product_id: ProductUUID.NAMIRASOFT_LOG,
			name: "log",
			tables: [{ table: namirasoft.log.tables.log, required: true }],
			client: {
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.level, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.host, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log.columns.created_at, new DateTimeFormatter()),
					];
				},
				getListURL: () => { return LogRoutes.LogList(log_group_id) },
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: null,
			},
			server: {
				value_list: props.servers.log.value.List,
				get: async (id: string) =>
				{
					return await props.servers.log.log.Get(log_group_id, id);
				},
				list: async (filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]) =>
				{
					return props.servers.log.log.List(log_group_id, filters, page, size, sorts, null);
				},
				create: props.servers.log.log.Create,
				update: null,
				delete: null,
			}
		};
	}
	static log_group(props: NSARouterMakerResult & LogProps): IEntityInfo<LogGroupRow, LogGroupInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
		return {
			product_id: ProductUUID.NAMIRASOFT_LOG,
			name: "log_group",
			tables: [{ table: namirasoft.log.tables.log_group, required: true }],
			client: {
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.retention_unit, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.retention_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.log.tables.log_group.columns.updated_at, new DateTimeFormatter()),
					];
				},
				getListURL: () => LogRoutes.LogGroupList,
				getNewURL: () => LogRoutes.LogGroupNew,
				getCopyURL: (id: string) => LogRoutes.LogGroupCopy(id),
				getEditURL: (id: string) => LogRoutes.LogGroupEdit(id),
				getViewURL: (id: string) => LogRoutes.LogGroupView(id),
				getMenus: (getIDs) => { return { "Log Group": [LogMenus.showLogs(props, getIDs)] } }
			},
			server: {
				value_list: props.servers.log.value.List,
				get: props.servers.log.log_group.Get,
				list: props.servers.log.log_group.List,
				create: props.servers.log.log_group.Create,
				update: props.servers.log.log_group.Update,
				delete: props.servers.log.log_group.Delete,
			}
		};
	}
}